import {
  CreateContextProvider,
  Form,
  useCreateController,
  useNotify,
  useRefresh,
  useTranslate,
} from 'react-admin';
import { Button as MUIButton, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Resources } from '../../resource';
import LottoDrawConfigForm from './LottoDrawConfigForm';
import { createLottoDrawConfig } from '../../../services/redpacketService';
import { useFormContext } from 'react-hook-form';
import { PermissionButton } from '../../../../../routes/components/permission-button';

const CreateLottoDrawConfig = ({ onClose }: { onClose: () => void }) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();

  const controller = useCreateController({
    resource: Resources.redpacket,
    mutationOptions: {
      onSuccess: () => {
        notify('Created successfully', { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        notify(error.message || 'Creation failed', { type: 'error' });
      },
    },
  });

  const CustomSaveButton = () => {
    const { handleSubmit } = useFormContext();
    const onSubmit = async (data: any) => {
      try {
        await createLottoDrawConfig({
          drawTimeUtc: data.drawTimeUtc,
          prizeAmount: String(data.prizeAmount),
          totalBudget: String(data.totalBudget),
          fundPoolAddress: data.fundPoolAddress,
          eligibilityThreshold: Number(data.eligibilityThreshold),
          isActive: data.isActive ?? true,
        });
        notify('Created successfully', { type: 'success' });
        refresh();
        onClose();
      } catch (error: any) {
        notify(error.message || 'Creation failed', { type: 'error' });
      }
    };
    return <MUIButton onClick={handleSubmit(onSubmit)}>Save</MUIButton>;
  };

  return (
    <CreateContextProvider value={controller}>
      <Form disableInvalidFormNotification>
        <DialogTitle>Create Lotto Draw Config</DialogTitle>
        <DialogContent>
          <LottoDrawConfigForm isCreate />
        </DialogContent>
        <DialogActions>
          <MUIButton variant="outlined" onClick={onClose}>
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="redpacket" action="create">
            <CustomSaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </CreateContextProvider>
  );
};

export default CreateLottoDrawConfig;
